import { EARLY_BIRD_DISCOUNT_CUTOFF } from "@/constants/constants";
import { useScopedField } from "@ngt/forms-core";
import { useMemo } from "react";
import { DateTime } from "luxon";

export const useHasEarlyBirdDiscount = () => {
    const {state: {value: enteredDate}} = useScopedField<string>("enteredDate", {value: true}, undefined, false);

    return useMemo(() => {
        let comparisonDate = new Date();

        if (enteredDate) {
            comparisonDate = DateTime.fromISO(enteredDate).toJSDate();
        }

        return EARLY_BIRD_DISCOUNT_CUTOFF >= comparisonDate;
    }, [enteredDate]);
}